<script>
    import { onMount } from 'svelte';
    import Writer from './Writer.svelte';
    import { noteMock } from '../../mocks/Mocks.svelte';
    import url from '../../stores/url';
    import * as storeHelpers from '../../stores/helpers';
    export let postUid;
    export let navigateToNote;
    let content;
    let slug;
    let isPublished;
    let loaded = false;

    // $url.pathname from store changes before postUid from svelte-router params.
    // svelte-router might need to be deprecated.
    $: currentPostUid = $url.pathname.split('/notes/')[1];

    $: note = storeHelpers.queryGetNoteWithUuid(currentPostUid);

    $: {
        if (note) {
            ({ content, slug, isPublished } = note);
        }
    }

    function getNote() {
        fetch(`/api/v1/post/${postUid}`)
        .then(data => {
            return data.json()
        })
        .then(response => {
            const { post, status } = response;
            if (status === 401) {
                storeHelpers.clearAuth();
                navigate('/login');
                return;
            }

            ({ content, slug, isPublished } = post);
            loaded = true;
        });
    }

    function getMockNote() {
        ({ content, slug, isPublished } = noteMock.post);
        loaded = true;
    }

    onMount(() => {
        getNote();
        // getMockNote();
    });

    const savePost = (sourceList) => {
        fetch(`/api/v1/post/save`, {
            body: JSON.stringify({ postUid, content: sourceList }),
            method: 'POST',
        })
        .then(data => data.json())
        .then(response => {
            const { postUid } = response;
            console.log({ postUid });
        });
    };
</script>

<main>
    {#if loaded}
        {#if content}
            <Writer
                markdownSourceList={content}
                savePost={savePost}
                navigateToNote={navigateToNote}
                postUid={postUid}
                slug={slug}
                isPublished={isPublished}
            />
        {:else}
            <div>Could not find this note</div>
        {/if}
    {:else}
        <div>loading...</div>
    {/if}
    
</main>